<template>       
    <div class="clearfix ">  
        <b-form @submit.stop.prevent="onSubmit" class="">

            <b-form-group id="name-group" label="Code" class="required-field" label-for="name">
                <b-form-input id="name" name="name" v-model="fdata.name" v-validate="{ required: true, min: 3 }" :state="validateState('name')" aria-describedby="name-feedback" data-vv-as="Code"></b-form-input>
                <b-form-invalid-feedback id="name-feedback">{{ veeErrors.first('name') }}</b-form-invalid-feedback>
            </b-form-group>

            <b-form-group id="title-group" label="Title" class="required-field" label-for="title">
                <b-form-input id="title" name="title" v-model="fdata.title" v-validate="{ required: true, min: 3 }" :state="validateState('title')" aria-describedby="title-feedback" data-vv-as="Title"></b-form-input>
                <b-form-invalid-feedback id="title-feedback">{{ veeErrors.first('title') }}</b-form-invalid-feedback>
            </b-form-group>

            <b-form-group id="full_access-group" label="" label-for="full_access">
                <b-form-checkbox id="full_access" v-model="fdata.full_access" name="full_access" value="1" unchecked-value="0">Required Full Access</b-form-checkbox>
            </b-form-group>

            <b-form-group id="need_approval-group" label="" label-for="need_approval">
                <b-form-checkbox id="need_approval" v-model="fdata.need_approval" name="need_approval" value="1" unchecked-value="0">Need Approval</b-form-checkbox>
            </b-form-group>

            <b-form-group label="Group" >
                <b-form-radio-group                            
                    v-model="fdata.group_id"
                    :options="groups"
                ></b-form-radio-group>
            </b-form-group>
            <b-button type="submit" variant="success" >Save</b-button>            
        </b-form>
    </div>
</template>


<script>
    export default{
        
        mounted() {
            
        },
        props: [],
        data(){            
            
            return {                
                
                fdata: {id:null, name:'', full_access:0, need_approval:0, group_id:1}, 
                groups : [],               
                
            }
        },
        methods:{

            getResourceGroups: function()
            {
                if(!this.checkNet()) return false;
                let currentObj = this;
                axios.get(this.$api_url+'/acl/resource/groups' , {
                    params: {
                        
                    }
                }).then(function(response){
                    this.groups = response.data;                    

                }.bind(this)).catch(function (error){
                    currentObj.serverError(error);
                });
            },
            
            onSubmit(e) 
            {
                if(!this.checkNet()) return false;
                         
                this.warningmsg = null; 
                this.successmsg = null;
                //this.showMessage();

                this.$validator.validateAll().then(result => {
                    if (!result) {
                        return;
                    }

                    e.preventDefault();
                    let currentObj = this;                   

                    let formData = new FormData();
                                        
                    for (let [key, value] of Object.entries(this.fdata)) 
                    {                    
                        var nm = `${key}`;
                        var fval = `${value}`;
                        formData.append(nm, fval);                    
                        //console.log(`${key}: ${value}`);
                    } 

                    axios.post(this.$api_url+'/acl/new/resource', formData)
                                .then(function (response) 
                                {                                    
                                    
                                    this.$bvToast.toast('Saved!', {
                                            title: `Success`,
                                            variant: 'success',
                                            solid: true
                                        });
                                
                                    this.$bvModal.hide('bv-modal-new-resource');
                                    
                                }.bind(this))
                                .catch(function (error) 
                                {
                                    currentObj.$bvToast.toast('Duplicate resource found', {
                                            title: `Failed`,
                                            variant: 'danger',
                                            solid: true
                                        });
                                    currentObj.serverError(error);
                                });
                });
            },

        },
        created: function(){
            this.getResourceGroups();
        },        
    }
</script>